<template>
	<div style="width: fit-content;">
		<canvas
			v-bind:id="'thumbnail'+dir"
			class="thumbnail"
			:alt="dir"
			v-on:click="imageClick"
            :style="thumbnailStyle"
		/>
		<p v-if="doc_id!=undefined" class="subtext">{{doc_id}}</p>
		<div v-bind:id="'myModal'+dir" class="modal">
			<canvas v-bind:id="'img'+dir" :class="isZoomed"/>
			<div v-if="zoomed==false" class="modal-button-group-light">
				<button class="modal-button" v-on:click="close"><font-awesome-icon class="modal-button-icon-light" size="3x" icon="times" /></button>
				<button class="modal-button" v-on:click="zoom"><font-awesome-icon class="modal-button-icon-light" size="3x" icon="expand" /></button>
				<button class="modal-button" v-on:click="copy"><font-awesome-icon class="modal-button-icon-light" size="3x" icon="save" /></button>
			</div>
			<div v-else class="modal-button-group-dark">
				<button class="modal-button" v-on:click="close"><font-awesome-icon class="modal-button-icon-dark" size="3x" icon="times" /></button>
				<button class="modal-button" v-on:click="zoom"><font-awesome-icon class="modal-button-icon-dark" size="3x" icon="compress" /></button>
				<button class="modal-button" v-on:click="copy"><font-awesome-icon class="modal-button-icon-dark" size="3x" icon="save" /></button>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
import img_manip from '@/img_manip'
export default {
    props: {
        dir: String,
		id: {
			type: Number,
			required: false,
			default: -1
		},
		rotation: {
			type: Number,
			required: false,
			default: 0
		},
		brightness: {
			type: Number,
			required: false,
			default: 0
		},
		contrast: {
			type: Number,
			required: false,
			default: 0
		},
		translateX: {
			type: Number,
			required: false,
			default: 0
		},
		translateY: {
			type: Number,
			required: false,
			default: 0
		},
		scale: {
			type: Number,
			required: false,
			default: 100
		},
		crop: {
			type: Array,
			required: false,
			default: [0,0,0,0]
		},
        enforceMax: {
            type:String,
            required: false,
            default: null
        },
		doc_id: String,
		save: Boolean,
		grid: Boolean,
    },
	data() {
		return {
			originalData:Uint8ClampedArray,
			imageData:ImageData,
			img:HTMLImageElement,
			zoomed:false,
		}
	},
	mounted () {
		let stateCheck = setInterval(() => {
			if (document.getElementById("thumbnail"+this.dir)!=null) {
				clearInterval(stateCheck);
				this.setImage();
			}
		}, 100);
	},
	methods:{
		async imageClick(){
			var modal = document.getElementById("myModal"+this.dir);

			modal.style.display = "block";
            this.$emit('input',  this.id);
		},
		async close(){
			var modal = document.getElementById("myModal"+this.dir);
			modal.style.display = "none";
			this.zoomed=false;
		},
		async zoom(){
			this.zoomed=!this.zoomed;
		},
		async copy(){
			var gh = document.getElementById("thumbnail"+this.dir).toDataURL();

			var a  = document.createElement('a');
			a.href = gh;
			a.download = 'document_'+this.doc_id+'.png';

			a.click()
		},
		setImage(){
			api.getImage(
                {
                    data:{
						filename:this.dir
					}
                }
            ).then((res) => {
				this.img = document.createElement('img')
				this.img.src="data:image/png;base64, "+res.data;

				let stateCheck = setInterval(() => {
					if (this.img.complete) {
						clearInterval(stateCheck);
						this.setImageData()
					}
				}, 100);
	        });
		},
		setImageData(){
			var modal = document.getElementById("img"+this.dir);
			modal.width = this.img.width;
			modal.height = this.img.height;
			var modalContext = modal.getContext('2d');
			modalContext.drawImage(this.img, 0, 0);

			var canvas = document.getElementById("thumbnail"+this.dir);
			canvas.width = this.img.width;
			canvas.height = this.img.height;
			var context = canvas.getContext('2d');

			context.drawImage(this.img, 0, 0);

			this.imageData = context.getImageData(0, 0, canvas.width, canvas.height);
			this.originalData = new Uint8ClampedArray(this.imageData.data);
			this.setCanvas();
		},
		setCanvas(){
			document.getElementById("thumbnail"+this.dir).getContext('2d').putImageData(this.imageData, 0, 0);
			document.getElementById("img"+this.dir).getContext('2d').putImageData(this.imageData, 0, 0);
		},
		saveImage(){
			var url = document.getElementById("thumbnail"+this.dir).toDataURL().split(',')[1];
			var origUrl = this.img.src.split(',')[1];
			api.getImage(
                {
                    data:{
						filename:this.dir,
						urlData:url,
						origUrlData:origUrl,
					}
                }
            ).then((res) => {/*
				var img = document.createElement('img')
				img.src="data:image/png;base64, "+res.data;
				this.setImageData(img)*/
	        });
		},
		applyImageManip(){
			this.imageData.data.set(this.originalData);
			img_manip.setContrast(this.imageData.data, this.contrast).then((res)=>{
				img_manip.setBrightness(this.imageData.data, this.brightness).then((res)=>{
					this.imageData.data.set(res);
					this.setCanvas();

					if(this.grid==true){
						this.drawGrid();
					}
				})
			})
		},
		applyTransform(){
			var rot = this.rotation*Math.PI/180;
			var transX = this.translateX;
			var transY = this.translateY;
			var scale = this.scale/100;

			var inverted = Math.abs(Math.cos(rot))>0.7071;

			var canvas =  document.getElementById("thumbnail"+this.dir);
			var modal = document.getElementById("img"+this.dir);
			var imgClone = this.img.cloneNode(true);
			var context = canvas.getContext('2d');

			if(inverted){
				canvas.width = imgClone.width;
				canvas.height = imgClone.height;
				modal.width = imgClone.width;
				modal.height = imgClone.height;
			}else{
				canvas.width = imgClone.height;
				canvas.height = imgClone.width;
				modal.width = imgClone.height;
				modal.height = imgClone.width;
			}
			/*Clear the canvas*/
			context.beginPath();
			context.rect(0, 0, canvas.width, canvas.height);
			context.fillStyle = "white";
			context.fill();

			/*Apply Transformations and draw image*/
			context.translate(canvas.width/2 + transX, canvas.height/2 - transY);
			context.rotate(rot);
			context.scale(scale,scale);

			if(inverted){
				context.drawImage(imgClone, -canvas.width/2, -canvas.height/2);
			}else{
				context.drawImage(imgClone, -canvas.height/2, -canvas.width/2);
			}

			context.scale(1/scale,1/scale);
			context.rotate(-rot);
			context.translate(-canvas.width/2 - transX, -canvas.height/2+ transY);

			/*Draw the crop*/
			context.beginPath();
			context.rect(canvas.width-this.crop[0], 0, this.crop[0], canvas.height);
			context.fillStyle = "white";
			context.fill();

			context.beginPath();
			context.rect(0, 0, this.crop[1], canvas.height);
			context.fillStyle = "white";
			context.fill();

			context.beginPath();
			context.rect(0, 0, canvas.width, this.crop[2]);
			context.fillStyle = "white";
			context.fill();

			context.beginPath();
			context.rect(0, canvas.height-this.crop[3], canvas.width, this.crop[3]);
			context.fillStyle = "white";
			context.fill();

			/*Apply Image*/
			this.imageData = context.getImageData(0, 0, canvas.width, canvas.height);
			this.originalData = new Uint8ClampedArray(this.imageData.data);
			this.setCanvas();

			this.applyImageManip();
		},
		drawGrid(){
			var canvas =  document.getElementById("thumbnail"+this.dir);
			var context = canvas.getContext('2d');

			var lineWidth = 5;
			var verticalLineOffset = canvas.height/4;
			var horizontalLineOffset = canvas.height/4;
			var color = "#999999";

			context.beginPath();
			context.rect(0, verticalLineOffset, canvas.width, lineWidth);
			context.fillStyle = color;
			context.fill();

			context.beginPath();
			context.rect(0, canvas.height/2, canvas.width, lineWidth);
			context.fillStyle = color;
			context.fill();

			context.beginPath();
			context.rect(0, canvas.height-verticalLineOffset, canvas.width, lineWidth);
			context.fillStyle = color;
			context.fill();

			context.beginPath();
			context.rect(horizontalLineOffset, 0, lineWidth, canvas.height);
			context.fillStyle = color;
			context.fill();

			context.beginPath();
			context.rect(canvas.width-horizontalLineOffset, 0, lineWidth, canvas.height);
			context.fillStyle = color;
			context.fill();
		}
	},
	watch:{
		save(){
			this.saveImage();
		},
		dir(){
			this.setImage();
		},
		id(){
			this.setImage();
		},
		doc_id(){
			this.setImage();
		},
		brightness(){
			this.applyImageManip();
		},
		contrast(){
			this.applyImageManip();
		},
		rotation(){
			this.applyTransform();
		},
		translateX(){
			this.applyTransform();
		},
		translateY(){
			this.applyTransform();
		},
		scale(){
			this.applyTransform();
		},
		grid(){
			this.applyTransform();
		},
		crop(){
			this.applyTransform();
		},
	},
	computed: {
		isZoomed() {
			return this.zoomed ? 'modal-content-zoom' : 'modal-content';
		},
        thumbnailStyle() {
            if (this.enforceMax !== null) {
                return {
                    'max-height': `calc(100vh - ${this.enforceMax})`
                };
            }
            return {}; // no inline style if null
        }
	}
}
</script>

<style scoped>
.subtext{
	font-size: 12px;
	font-weight: normal;
	display:flex;
	flex-wrap: wrap;
	justify-content:left;
    width: fit-content;
}

.infoText{
	width:100%;
	text-align:center;
	font-size:20px;
	color:white;
}

.thumbnail{
	max-width:100%;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 5px;
	cursor: pointer;
	transition-duration: 0.4s;
}
.thumbnail:hover {opacity: 0.7;}

.modal {
	display: absolute;
	position: fixed;
	z-index: 20;
	padding: 5px;
	left: 0;
	top: 0;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.9);
}

.modal-content {
	margin: auto;
	max-height:100%;
	max-width:100%;
	display: block;
	object-fit:contain;
	background-color: rgba(0,0,0,0);
}

.modal-content-zoom {
	margin: auto;
	width:100%;
	display: block;
	object-fit:contain;
	background-color: rgba(0,0,0,0);
}

.modal-button-group-light{
	position:fixed;
	margin:5px;
	background-color:white;
	top:5px;
}
.modal-button-group-dark{
	position:fixed;
	margin:5px;
	background-color:#999;
	top:5px;
}

.modal-button{
	padding:5px;
	margin-bottom:5px;
	background-color:transparent;
	border:none;
}

.modal-button-icon-light{
	color: #999;
}
.modal-button-icon-dark{
	color: white;
}

</style>



// WEBPACK FOOTER //
// src/layouts/document.vue